// src/pages/NotFoundPage.js
// Updated: 10/17/2025 09:55 AM

import React from 'react';

const NotFoundPage = () => {
  return <h1>404 - Page Not Found</h1>;
};

export default NotFoundPage;